import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationResponse } from '../../models/notificationModel/NotificationResponse';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  private base = environment.urlServerApi+'notifications';

  constructor(private _http: HttpClient){
  }

  getNotRead(userEmail: string){
    return this._http.get<NotificationResponse>(`${this.base}/users?userEmail=${userEmail}`);
  }

  markAsRead(notificationId:number, userEmail: string){
    var marck = {
      notificationId: notificationId,
      userEmail: userEmail
    }
    return this._http.post<NotificationResponse>(`${this.base}`, marck);
  }
}
